module.exports = {
	"actual": {
		"cs-CZ": "Aktuálně",
		"en-GB": "Info",
		"fr-FR": "Infos",
		"de-DE": "Aktuell"
	},
	"about": {
		"cs-CZ": "O souboru",
		"en-GB": "About us",
		"fr-FR": "Notre ensemble",
		"de-DE": "Musik"
	},
	"discography": {
		"cs-CZ": "Diskografie",
		"en-GB": "Discography",
		"fr-FR": "Discographie",
		"de-DE": "Discographie"
	},
	"concerts": {
		"cs-CZ": "Koncerty",
		"en-GB": "Concerts",
		"fr-FR": "Concerts",
		"de-DE": "Konzertwessen"
	},
	"photos": {
		"cs-CZ": "Fotogalerie",
		"en-GB": "Photogallery",
		"fr-FR": "Photogalerie",
		"de-DE": "Photogalery"
	},
	"service": {
		"cs-CZ": "Nabízíme",
		"en-GB": "Service",
		"fr-FR": "Service",
		"de-DE": "Bieten wir an"
	},
	"contacts": {
		"cs-CZ": "Kontakty",
		"en-GB": "Contacts",
		"fr-FR": "Contacts",
		"de-DE": "Kontaktliste"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Navbar/Navbar.json
// module id = 3
// module chunks = 0